import doSetNotificationsAsReaded from '@/api/doSetNotificationsAsReaded';
import doUpdateNotificationsSettings from '@/api/doUpdateNotificationsSettings';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { NotificationSettingsPayload } from '@/types/notifications';
import { DashboardEnum } from '@/types/translations/DashboardEnum';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRef } from 'react';
import { Id, toast } from 'react-toastify';
function useMutateNotifications() {
  const mutateNotificationsAsReaded = useMutation({
    mutationFn: doSetNotificationsAsReaded,
    mutationKey: ['notifications/set-notifications-as-readed'],
  });

  return {
    mutateNotificationsAsReaded,
  };
}

function useMutateNotificationSettings() {
  const { translate } = useTypedTranslation<DashboardEnum>('dashboard');
  const toastId = useRef<Id | null>(null);
  const queryClient = useQueryClient();
  const mutateNotificationSettings = useMutation({
    mutationFn: (payload: NotificationSettingsPayload) => doUpdateNotificationsSettings(payload),
    onError: () => {
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toast.error(translate(DashboardEnum['notifications_settings_update_error']));
    },
    onMutate: () => {
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toastId.current = toast.loading(
        translate(DashboardEnum['notifications_settings_update_loading'])
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['notification_settings'],
      });
      if (toastId.current) {
        toast.dismiss(toastId.current);
      }
      toast.success(translate(DashboardEnum['notifications_settings_update_success']));
    },
    mutationKey: ['notifications/update-notifications-settings'],
  });

  return {
    mutateNotificationSettings,
  };
}

export { useMutateNotifications, useMutateNotificationSettings };
